module.exports = __webpack_public_path__ + "img/pill.c769dd7c.png";